import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { HttpResult } from "../../core/services/base-http.service";
import { APIErrorModel, BaseResponse } from "../../shared/models/base-response.model";
import { VirtualEventApiService } from "./virtual-event-api.service";

@Injectable({
    providedIn: "root",
})
export class VirtualEventBllService {

    constructor(
        private virtualEventApiService: VirtualEventApiService,
    ) { }

    async submitRegisterVirtualVisitor() {
        const result: HttpResult<BaseResponse<any>> =
            await firstValueFrom(this.virtualEventApiService.registerVirtualVisitor());

        const { status, body } = result;

        if (status === 200) {
            // Return data if status is OK
            return body;
        } else {
            // Throw error with status and message if request fails
            throw <APIErrorModel>{
                status,
                message: body.message,
                data: body.data,
            };
        }
    }
}
